import React, { useEffect, useState, useRef } from 'react';
import './../Styles/Admin.css';
import logoLight from './../Images/tsqs-hm-ft-logo1.gif';
import logoDark from './../Images/tsqs-hm-ft-logo.gif';
import axios from 'axios';
import CreateGoal from './CreateGoal';
import AssignGoal from './AssignGoal';
import lottie from 'lottie-web';
import Lottie from 'lottie-react';
import comingSoonAnimation from './../ani/comingsoon.json';
import Notifications from './../Components/Notifications'; // Import Notifications component
import EmployeeDetailsDialog from './EmployeeDetailsDialog';
import { TailSpin } from 'react-loader-spinner'; // Using react-loader-spinner
import MESection from './MESection'; // Import the M&E component
import Organization from './Organization'; // Import the Organization component
import ProfileDialog from './ProfileDialog';
import { useToast } from './ToastContext';
import { useConfirm } from './ConfirmDialog';
import AppHeader from './AppHeader';
const apiUrl = process.env.REACT_APP_API_URL;


const MainManager = () => {
    const showToast = useToast();
    const confirm = useConfirm();
    const [employees, setEmployees] = useState([]);
    const [showCreateGoalDialog, setShowCreateGoalDialog] = useState(false);
    const [showAssignGoalDialog, setShowAssignGoalDialog] = useState(false);
    const [managerInfo, setManagerInfo] = useState({ full_name: '', job_title: '' });
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [employeeDetails, setEmployeeDetails] = useState([]);
    const [finalRating, setFinalRating] = useState('');
    const [submissionSuccess, setSubmissionSuccess] = useState(false); // State for submission success message
    const VALID_MAIN_MANAGER_SECTIONS = ['employees', 'me', 'reports', 'projects', 'organization', 'updates'];
    const [currentSection, setCurrentSection] = useState(() => {
        const savedSection = localStorage.getItem('mainManager_currentSection');
        return VALID_MAIN_MANAGER_SECTIONS.includes(savedSection) ? savedSection : 'employees';
    });

    useEffect(() => {
        if (VALID_MAIN_MANAGER_SECTIONS.includes(currentSection)) {
            localStorage.setItem('mainManager_currentSection', currentSection);
        }
    }, [currentSection]);
    const reportsContainer = useRef(null);
    const projectsContainer = useRef(null);
    const performanceContainer = useRef(null);
    const updatesContainer = useRef(null);
    const [quarters, setQuarters] = useState([]);
    const [selectedQuarter, setSelectedQuarter] = useState(''); // Will be set after quarters load
    const [noGoalsMessage, setNoGoalsMessage] = useState('');
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    //profile
    const [isProfileDialogOpen, setProfileDialogOpen] = useState(false); // State for profile dialog
    const [selectedRole, setSelectedRole] = useState('all'); // State for roles filter
    const [selectedProject, setSelectedProject] = useState('all'); // State for project filter
    const [projects, setProjects] = useState([]); // State to hold all projects
    const [activeDropdown, setActiveDropdown] = useState(null); // State for active dropdown

    // Fetch quarters from DB
    useEffect(() => {
        axios.get(`${apiUrl}/api/quarters`)
            .then(res => {
                const qs = res.data.map(q => q.quarter);
                setQuarters(qs);
                if (qs.length > 0) setSelectedQuarter(qs[0]);
            })
            .catch(err => console.error('Error fetching quarters:', err));
    }, []);

    const handleDropdownClick = (dropdownName) => {
        setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.goals-dropdown')) {
                setActiveDropdown(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const fetchGoalsData = async () => {
        try {
            await axios.get(`${apiUrl}/api/goals`);
        } catch (error) {
            console.error('Error fetching goals:', error);
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    useEffect(() => {
        // Load and play the Lottie animations for different sections
        lottie.loadAnimation({
            container: reportsContainer.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: comingSoonAnimation,
        });

        lottie.loadAnimation({
            container: projectsContainer.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: comingSoonAnimation,
        });

        lottie.loadAnimation({
            container: performanceContainer.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: comingSoonAnimation,
        });

        lottie.loadAnimation({
            container: updatesContainer.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: comingSoonAnimation,
        });

       
        return () => {
            lottie.destroy();
        };
    }, []);


    //newly addedd 22-08:1:37
    useEffect(() => {
        const managerId = localStorage.getItem('employeeId');
        if (!managerId) {
            console.error('Manager ID not found in local storage.');
            return;
        }

        // Fetch manager info
        axios.get(`${apiUrl}/api/manager-info/${managerId}`)
            .then(response => {
                setManagerInfo(response.data);
                console.log('Manager Info:', response.data);


               const isMainManager = response.data.is_main_manager;
               console.log('isMainManager:', isMainManager); // Log to verify value

                // Fetch all users instead of just employees
                axios.get(`${apiUrl}/api/users`)
                
                .then(response => setEmployees(response.data))
                .catch(error => setError('Error fetching employee data: ' + error));

                // Fetch all projects for the dropdown filter
                axios.get(`${apiUrl}/api/fetch-projects`)
                .then(response => setProjects(response.data))
                .catch(error => console.error('Error fetching projects:', error));
            })
            .catch(error => setError('Error fetching manager info: ' + error));
    }, []);


    const handleCreateGoal = () => {
        setShowCreateGoalDialog(true);
    };

    // Handler to close both dialogs
    const closeDialogs = () => {
        setShowAssignGoalDialog(false);
        setShowCreateGoalDialog(false);
    };

    // Retrieve managerId from localStorage
    const managerId = localStorage.getItem('employeeId');


    const handleViewDetails = (employee, quarter) => {

        setEmployeeDetails([]); // Clear previous results
        setNoGoalsMessage(''); // Clear any previous message
        setSelectedEmployee(employee);
       
        axios.get(`${apiUrl}/api/employee-admin-goals/${employee.employee_number}/${encodeURIComponent(quarter)}`)
            .then(response => {
                if (response.data.length === 0) {
                    setEmployeeDetails([]);
                    setNoGoalsMessage(`No goals submitted for ${employee.employee_number} in ${quarter}.`);
                } else {
                    setEmployeeDetails(response.data);
                    setNoGoalsMessage(''); // Clear any previous message
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 404) {
                    setEmployeeDetails([]);
                    setNoGoalsMessage(`No goals submitted for ${employee.employee_number} in ${quarter}.`);
                } else {
                    console.error('Error fetching employee details:', error);
                }
            });
    };


    const handleFinalRatingChange = (rating) => {
        setFinalRating(rating);
    };

const handleReviewerRatingChange = (goalId, newRating) => {
    setEmployeeDetails(prevDetails =>
        prevDetails.map(detail =>
            detail.goal_id === goalId ? { ...detail, reviewer_rating: newRating } : detail
        )
    );
};

const handleSubmit = async () => {
    setLoading(true); // Start loading
    if (!selectedEmployee) return;
    console.log('submitting for:', selectedEmployee.employee_number);

    try {
        // Submit individual goal reviews
        const goalReviewsData = {
            goals: employeeDetails.map(detail => ({
                goalId: detail.goal_id,
                reviewerRating: detail.reviewer_rating,
            })),
            employeeId: selectedEmployee.employee_number,
        };

        const goalReviewsResponse = await axios.post(
            `${apiUrl}/api/submit-goal-reviews`,
            goalReviewsData
        );
        console.log("Goal reviews response:", goalReviewsResponse);

        // Submit final rating and reviewer comment
        const finalReviewData = {
            employeeId: selectedEmployee.employee_number,
            finalRating,
            reviewerComment: employeeDetails[0]?.reviewer_comment,
            quarter: selectedQuarter // Add the selected quarter here
        };

        const finalReviewResponse = await axios.post(
            `${apiUrl}/api/submit-final-review`,
            finalReviewData
        );

        console.log('Final review submitted:', finalReviewResponse.data);
        console.log('Goal reviews submitted:', goalReviewsResponse.data);
        // setSelectedEmployee(null);
        setLoading(false);   // Stop loading
        setSubmissionSuccess(true);

        // Reset the selected employee and success message after a delay
        setTimeout(() => {
            // setSelectedEmployee(null);
            setSubmissionSuccess(false);
        }, 6000); // 10  seconds delay
    } catch (error) {
        console.error('Error submitting data:', error);
        setLoading(false); // Stop loading on error
    }
};
 

//profile handling
const handleOpenProfileDialog = () => {
    setProfileDialogOpen(true);
};

const handleCloseProfileDialog = () => {
    setProfileDialogOpen(false);
};



    const renderDetailsDialog = () => {
        if (!selectedEmployee) return null;

        return (
            <div className="details-dialog-overlay">
                <div className="details-dialog">
                    <h2>Details of {selectedEmployee.full_name}</h2>
                    <div className="quarter-selector">
                    <label htmlFor="quarter">Select Quarter:</label>
                    <select
                        id="quarter"
                        value={selectedQuarter}
                        onChange={(e) => {
                            setSelectedQuarter(e.target.value);
                            handleViewDetails(selectedEmployee, e.target.value);
                        }}
                    >
                        {quarters.map(q => (
                            <option key={q} value={q}>{q}</option>
                        ))}
                    </select>
                </div>

                    <div className="employee-summary">
                        <div className="summary-item">
                            <p><strong>Full Name:</strong> {selectedEmployee.full_name}</p>
                        </div>
                        <div className="summary-item">
                            <p><strong>Location:</strong> {selectedEmployee.location}</p>
                        </div>
                        <div className="summary-item">
                            <p><strong>Job Title:</strong> {selectedEmployee.job_title}</p>
                        </div>
                        <div className="summary-item">
                            <p><strong>Department:</strong> {selectedEmployee.department}</p>
                        </div>
                    </div>
                    {employeeDetails.length > 0 ? (
                        <>
                            <table className="details-table">
                                <thead>
                                    <tr>
                                        {/* <th>Goal ID</th> */}
                                        <th>Goal Description</th>
                                        <th>Self Assessment</th>
                                        <th>Self Rating</th>
                                        <th>Communicated</th>
                                        <th>Attachments</th>
                                        <th>Reviewer Rating</th>
                                        <th rowSpan={employeeDetails.length + 1}>Final Rating</th> {/* New column header with row span */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {employeeDetails.map((detail, index) => (
                                        <tr key={detail.id}>
                                            {/* <td className="tabledisabled">{detail.goal_id}</td> */}
                                            <td className="tabledisabled">{detail.goal_description}</td>
                                            <td className="tabledisabled">{detail.self_assessment || 'N/A'}</td>
                                            <td className="tabledisabled">{detail.self_rating || 'N/A'}</td>
                                            <td className="tabledisabled">{detail.communicated ? 'Yes' : 'No'}</td>
                                            <td className="tabledisabled">
                                                {detail.attachments ? (
                                                    <a href={detail.attachments} target="_blank" className="attachment-link" rel="noopener noreferrer">
                                                        View Attachment
                                                    </a>
                                                ) : 'None'}
                                            </td>
                                            <td>
                                            <select
                                                    value={detail.reviewer_rating || ''}
                                                    onChange={(e) => handleReviewerRatingChange(detail.goal_id, e.target.value)}
                                                >
                                                    <option value="" disabled>Select</option>
                                                    {[1, 2, 3, 4, 5].map(rating => (
                                                        <option key={rating} value={rating}>{rating}</option>
                                                    ))}
                                                </select>
                                            </td>
                                            {index === 0 && (
                                                <td rowSpan={employeeDetails.length}>
                                                    <select 
                                                        value={finalRating} 
                                                        onChange={(e) => handleFinalRatingChange(e.target.value)}
                                                    >
                                                        <option value="" disabled>Select</option>
                                                        {[1, 2, 3, 4, 5].map(rating => (
                                                            <option key={rating} value={rating}>{rating}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="reviewer-comment-section">
                                <strong>Reviewer Comment:</strong>
                                <textarea 
                                    value={employeeDetails[0]?.reviewer_comment || ''} 
                                    onChange={(e) => setEmployeeDetails(prevDetails => {
                                        const updatedDetails = [...prevDetails];
                                        updatedDetails[0].reviewer_comment = e.target.value;
                                        return updatedDetails;
                                    })}
                                />
                            </div>
                        </>
                    ) : (
                        <p>No goals found for this employee.</p>
                    )}
                      {submissionSuccess && (
                        <div className={`submission-success-message ${submissionSuccess ? 'visible' : ''}`}>
                            Submitted successfully!
                        </div>
                    )}
                     {/* Display loading spinner and text */}
                     {loading && (
                         <div className="overlay-loading">
                         <div className="overlay-content-loading">
                         <TailSpin height="40" width="40" color="#00BFFF" />
                          <span className="loading-text-loading">Submitting Review...</span>
                         </div>
                         </div>
                      )}

                    <button onClick={() => setSelectedEmployee(null)}>Close</button>
                    <button onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        );
    };

    return (
        <div className="admin-page">
            <aside className="sidebar">
                <div className="logo-container">
                    <>
                      <img src={logoLight} alt="Company Logo" className="logo logo-light" />
                      <img src={logoDark} alt="Company Logo" className="logo logo-dark" />
                    </>
                </div>
                <nav className="nav-menu">
                    <a href="#" className={`nav-item ${currentSection === 'employees' ? 'active' : ''}`} onClick={() => setCurrentSection('employees')}>Employees</a>
                    <a href="#" className={`nav-item ${currentSection === 'me' ? 'active' : ''}`} onClick={() => setCurrentSection('me')}>Manager View</a>
                    <a href="#" className={`nav-item ${currentSection === 'organization' ? 'active' : ''}`} onClick={() => setCurrentSection('organization')}>Organization</a>
                    <a href="#" className={`nav-item ${currentSection === 'reports' ? 'active' : ''}`} onClick={() => setCurrentSection('reports')}> Reviewed Reports</a>
                    <a href="#" className={`nav-item ${currentSection === 'projects' ? 'active' : ''}`} onClick={() => setCurrentSection('projects')}>Project Reports</a>
                    {/* <a href="#" className={`nav-item ${currentSection === 'performance' ? 'active' : ''}`} onClick={() => setCurrentSection('performance')}>Performance Scale</a> */}
                    <a href="#" className={`nav-item ${currentSection === 'updates' ? 'active' : ''}`} onClick={() => setCurrentSection('updates')}>Updates</a>
                </nav>
            </aside>
            <main className="main-content">
                <AppHeader
                    title="PERFORMANCE MANAGEMENT SYSTEM"
                    employeeInfo={managerInfo}
                    onProfileClick={handleOpenProfileDialog}
                    hideLogo={true}
                />
                {currentSection !== 'me' && currentSection !== 'organization' && (
                    <div className="welcome-section">
                        <h1>Hi {managerInfo.full_name}...</h1>
                    </div>
                )}
                {currentSection === 'employees' && (
                <div className="employee-list-section">
                    <div className="employee-controls">
                        <div className="controls-left">
                            <h2>List of Employees</h2>
                            <div className={`goals-dropdown ${activeDropdown === 'goals' ? 'active' : ''}`}>
                                <button className="dropbtn" onClick={() => handleDropdownClick('goals')}>Goals ▼</button>
                                <div className="goals-dropdown-content">
                                    <a href="#" onClick={(e) => { handleCreateGoal(e); setActiveDropdown(null); }}>Create Goals</a>
                                    <a href="#" onClick={() => { setShowAssignGoalDialog(true); setActiveDropdown(null); }}>Assign Goals</a>
                                </div>
                            </div>
                            <div className={`goals-dropdown ${activeDropdown === 'projects' ? 'active' : ''}`}>
                                <button className="dropbtn" onClick={() => handleDropdownClick('projects')}>Projects ▼</button>
                                <div className="goals-dropdown-content">
                                    <a href="#" onClick={(e) => { e.preventDefault(); setSelectedProject('all'); setActiveDropdown(null); }}>All</a>
                                    {projects.map(proj => (
                                        <a href="#" key={proj._id} onClick={(e) => { e.preventDefault(); setSelectedProject(proj._id); setActiveDropdown(null); }}>
                                            {proj.project_name || proj._id}
                                        </a>
                                    ))}
                                </div>
                            </div>
                            <div className={`goals-dropdown ${activeDropdown === 'roles' ? 'active' : ''}`}>
                                <button className="dropbtn" onClick={() => handleDropdownClick('roles')}>Roles ▼</button>
                                <div className="goals-dropdown-content">
                                    <a href="#" onClick={(e) => { e.preventDefault(); setSelectedRole('all'); setActiveDropdown(null); }}>All</a>
                                    <a href="#" onClick={(e) => { e.preventDefault(); setSelectedRole('admin'); setActiveDropdown(null); }}>Manager</a>
                                    <a href="#" onClick={(e) => { e.preventDefault(); setSelectedRole('lead'); setActiveDropdown(null); }}>Lead</a>
                                    <a href="#" onClick={(e) => { e.preventDefault(); setSelectedRole('employee'); setActiveDropdown(null); }}>Employee</a>
                                </div>
                            </div>
                             {showAssignGoalDialog && (
                                 <AssignGoal
                                     loggedInManagerId={managerId}
                                     isMainManagerFlag={1}
                                     onClose={() => setShowAssignGoalDialog(false)}
                                 />
                             )}
                        </div>
                        <div className="controls-right">
                            {/* <input type="text" placeholder="Search..." className="search-bar"  onChange={handleSearchChange} /> */}
                            {/* <button className="sort-button">Filter</button> */}
                        </div>
                    </div>
                    
                  
                    <div className="employee-table-wrapper">
                        <table className="employee-table">
                            <thead>
                                <tr>
                                    <th>Employee Number</th>
                                    <th>Full Name</th>
                                    <th>Job Title</th>
                                    <th>Department</th>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {employees
                                    .filter(employee => selectedRole === 'all' || (employee.role && employee.role.toLowerCase() === selectedRole))
                                    .filter(employee => selectedProject === 'all' || employee.project_id === selectedProject)
                                    .map(employee => (
                                    <tr key={employee.employee_number || employee._id}>
                                        <td>{employee.employee_number || 'N/A'}</td>
                                        <td>{employee.full_name || employee.name || 'N/A'}</td>
                                        <td>{employee.job_title || 'N/A'}</td>
                                        <td>{employee.department || 'N/A'}</td>
                                        <td>
                                            <button className="details-button" onClick={() => handleViewDetails(employee, selectedQuarter)}>View</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                 )}
                 
                 {currentSection === 'me' && (
                   <div className="me-section">
                  <MESection managerName={managerInfo.full_name ? managerInfo.full_name.split(' ')[0] : 'Sudheer'} /> {/* Render M&E section */}
                  </div>
                  )}

                {currentSection === 'reports' && (
                    <div >
                       Reports COMING SOON...
                          <Lottie animationData={comingSoonAnimation} className="card-animation" />
                    </div>
                )
                }
                
                {currentSection === 'projects' && <div>
                    Projects COMING SOON...
                    <Lottie animationData={comingSoonAnimation} className="card-animation" />
                    </div>}

                {currentSection === 'performance' && <div>
                    Performance COMING SOON...
                    <Lottie animationData={comingSoonAnimation} className="card-animation" /></div>}

                {currentSection === 'organization' && (
                    <div className="organization-section-wrapper">
                        <Organization managerName={managerInfo.full_name ? managerInfo.full_name.split(' ')[0] : 'Sudheer'} />
                    </div>
                )}

                {currentSection === 'updates' && (
                    <div className="updates-section">
                        {/* Render Notifications Component when 'Updates' is selected */}
                        <Notifications managerId={managerId} />
                    </div>
                )}
              

            </main>
            {showCreateGoalDialog && <CreateGoal onClose={() => setShowCreateGoalDialog(false)} onGoalCreated={fetchGoalsData} />}

            {renderDetailsDialog()}
            {isProfileDialogOpen && (
                <ProfileDialog
                    employeeInfo={managerInfo}
                    onClose={handleCloseProfileDialog}
                    onUpdate={(updatedData) => setManagerInfo(prev => ({ ...prev, ...updatedData }))}
                />
            )}
        </div>
    );
};

export default MainManager;
